import Vue from "vue";
import Vuex from "vuex";

// export const CSV_UPLOAD_FILE = "csvuploadfile";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    csvUploadList: [],
  },
  mutations: {
    // [CSV_UPLOAD_FILE](state, data) {
    //   state.csvUploadList = data;
    // },
  },
  actions: {},
  modules: {},
});
